import React from "react";

const AlertError = ({ message }) => {
  return (
    <div
      className="mt-4 p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
      role="alert"
    >
      <span className="font-xs">Error:</span> {message}!
    </div>
  );
};

export default AlertError;
